import { forwardRef } from "react";
import { useBreakpointValue } from "@chakra-ui/react";
import { BoxProps } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IPlacement } from "src/components-mui/common/typeahead/typeahead.types";
import { GlobalNavSearchUi } from "./global-nav-search-ui";
import { GlobalTypeaheadWrapper } from "./global-typeahead-wrapper";

interface IProps extends Omit<BoxProps, "ref"> {
    isOpen?: boolean;
    navHeights: number[];
    onSearchClose: () => void;
    searchPlaceholderText?: string;
    placement?: IPlacement;
}

export const GlobalNavSearch = forwardRef<HTMLDivElement, IProps>(function GlobalNavSearch(
    { navHeights, onSearchClose, searchPlaceholderText, placement = "top", ...otherProps },
    ref
) {
    const { t } = useTranslation("common");
    const placeholderKey = (useBreakpointValue(["typeahead-placeholder-mobile", "typeahead-placeholder"]) ?? "typeahead-placeholder") as
        | "typeahead-placeholder-mobile"
        | "typeahead-placeholder";

    return (
        <GlobalNavSearchUi navHeights={navHeights} onSearchClose={onSearchClose} ref={ref} {...otherProps}>
            <GlobalTypeaheadWrapper placement={placement} placeholderText={searchPlaceholderText ?? t(placeholderKey)} enableAutoFocus />
        </GlobalNavSearchUi>
    );
});
